<div [attr.id]="id" class="p-tabview-panel" [hidden]="!selected" role="tabpanel" [attr.aria-hidden]="!selected"
     [attr.aria-labelledby]="id + '-label'" *ngIf="!closed()">
    <!--<ng-content></ng-content>-->
    <ng-container *ngIf="contentTemplate && (cache ? loaded() : selected)">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </ng-container>
</div>
